export class OperacionInforInfractorDto {
  idInfractor: string;
  Observacions: String;
  idDomicili: string;
  nom: string;
}
